// Sample prompts and engine answers the feature tabs' Track and Analyze panels render.
// Illustrative data, captioned as a sample on the page.

export type EngineKey = 'chatgpt' | 'perplexity' | 'google_aio'

interface PromptRow {
  query: string
  chatgpt: boolean
  perplexity: boolean
  google_aio: boolean
  trend: string
  up: boolean | null
}

interface ResponsePart {
  text: string
  type: 'normal' | 'brand' | 'competitor'
}

export const PROMPT_ROWS: PromptRow[] = [
  {
    query: 'best B2B CRM software',
    chatgpt: true,
    perplexity: true,
    google_aio: false,
    trend: '+12%',
    up: true,
  },
  {
    query: 'CRM for startups',
    chatgpt: true,
    perplexity: false,
    google_aio: true,
    trend: '+5%',
    up: true,
  },
  {
    query: 'CRM with Slack integration',
    chatgpt: false,
    perplexity: true,
    google_aio: true,
    trend: '-3%',
    up: false,
  },
  {
    query: 'affordable CRM for small teams',
    chatgpt: false,
    perplexity: false,
    google_aio: true,
    trend: '0%',
    up: null,
  },
]

export const ENGINE_DATA: Record<
  EngineKey,
  {
    label: string
    logo: string
    parts: ResponsePart[]
    position: number | null
    total: number
    sources: string[]
  }
> = {
  chatgpt: {
    label: 'ChatGPT',
    logo: '/images/ai-platforms/chatgpt-logo.svg',
    parts: [
      { text: 'For B2B teams, ', type: 'normal' },
      { text: 'Salesforce', type: 'competitor' },
      { text: ' remains the enterprise standard with deep customization. ', type: 'normal' },
      { text: 'HubSpot', type: 'competitor' },
      { text: ' is popular among mid-market teams. ', type: 'normal' },
      { text: 'Acme CRM', type: 'brand' },
      {
        text: ' is gaining traction among growth-stage startups for its transparent pricing and developer-friendly API.',
        type: 'normal',
      },
    ],
    position: 3,
    total: 5,
    sources: ['g2.com', 'trustradius.com', 'salesforce.com'],
  },
  perplexity: {
    label: 'Perplexity',
    logo: '/images/ai-platforms/perplexity-logo.svg',
    parts: [
      { text: 'The B2B CRM landscape is led by ', type: 'normal' },
      { text: 'Salesforce', type: 'competitor' },
      { text: ', which commands over a third of enterprise deals. ', type: 'normal' },
      { text: 'HubSpot', type: 'competitor' },
      { text: ' has expanded into sales and service hubs. ', type: 'normal' },
      { text: 'Pipedrive', type: 'competitor' },
      {
        text: ' suits sales-focused teams that want a clean pipeline view.',
        type: 'normal',
      },
    ],
    position: null,
    total: 5,
    sources: ['salesforce.com', 'hubspot.com', 'g2.com', 'capterra.com'],
  },
  google_aio: {
    label: 'Google AI Overview',
    logo: '/images/ai-platforms/google-aio-logo.svg',
    parts: [
      {
        text: 'Top B2B CRM recommendations include ',
        type: 'normal',
      },
      { text: 'Salesforce', type: 'competitor' },
      { text: ' for large enterprises, ', type: 'normal' },
      { text: 'Acme CRM', type: 'brand' },
      {
        text: ' for growth-stage teams with its flat-rate pricing, and ',
        type: 'normal',
      },
      { text: 'HubSpot', type: 'competitor' },
      {
        text: ' for marketing-led organizations.',
        type: 'normal',
      },
    ],
    position: 2,
    total: 5,
    sources: ['hubspot.com', 'salesforce.com', 'capterra.com/crm-software'],
  },
}
